const financialOrder = [
  {
    path: '/financial/orders',
    name: 'ToReceiveOrders',
    redirect: { name: 'ToReceivePayments' },
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/order/ToReceiveOrders'),
    children: [
      {
        meta: {
          auth: true,
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: 'to_receive',
        name: 'ToReceivePayments',
        component: () => import('@/_backoffice/_financial/components/order/ToReceivePayments'),
        children: [
          {
            meta: {
              auth: true,
              roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
            },
            path: 'protest/:id',
            name: 'ToProtest',
            component: () => import('@/_backoffice/_financial/components/order/ProtestVrtTransaction.vue'),
          },
          {
            meta: {
              auth: true,
              roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
            },
            path: 'update_date_expired/:id',
            name: 'UpdateDateExpired',
            component: () => import('@/_backoffice/_financial/components/order/UpdateDateExpired.vue'),
          }
        ]
      },
    ]
  },
]

export default financialOrder
